import { cn } from '@forest/shared'

export function GemIcon(props: { class?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      aria-hidden="true"
      class={cn('size-5 shrink-0', props.class)}
    >
      <defs>
        <linearGradient
          id="gem-grad-top"
          x1="-137.24"
          y1="833.13"
          x2="-137.24"
          y2="844.52"
          gradientTransform="matrix(1 0 0 -1 147.24 848.82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#6dd4cb" />
          <stop offset="1" stop-color="#cde7da" />
        </linearGradient>
        <linearGradient
          id="gem-grad-left-low"
          x1="357.13"
          y1="374.33"
          x2="357.13"
          y2="371.08"
          gradientTransform="matrix(0 -1 -1 0 375.8 367.12)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#41aeb8" />
          <stop offset="1" stop-color="#3ba1b5" />
        </linearGradient>
        <linearGradient
          id="gem-grad-top-left"
          x1="5.88"
          y1="2.85"
          x2="7.63"
          y2="5.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#69dadc" />
          <stop offset="1" stop-color="#4cb7c2" />
        </linearGradient>
        <linearGradient
          id="gem-grad-top-right"
          x1="273.2"
          y1="530.86"
          x2="275.86"
          y2="529.06"
          gradientTransform="matrix(0 -1 -1 0 542.99 279.01)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9de0d9" />
          <stop offset="1" stop-color="#c1e1ce" />
        </linearGradient>
        <linearGradient
          id="gem-grad-right-low"
          x1="357.11"
          y1="360.67"
          x2="357.11"
          y2="357.74"
          gradientTransform="matrix(0 -1 -1 0 375.8 367.12)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#4cb7c2" />
          <stop offset="1" stop-color="#69dadc" />
        </linearGradient>
        <linearGradient
          id="gem-grad-bottom-right"
          x1="12.57"
          y1="14.47"
          x2="14.1"
          y2="17.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#3ba1b5" />
          <stop offset="1" stop-color="#41aeb8" />
        </linearGradient>
        <linearGradient
          id="gem-grad-bottom-left"
          x1="350"
          y1="369.91"
          x2="352.58"
          y2="368.25"
          gradientTransform="matrix(0 -1 -1 0 375.8 367.12)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#50a4b7" />
          <stop offset="1" stop-color="#438694" />
        </linearGradient>
        <clipPath id="gem-clip">
          <path
            d="M1.71 5.46v9.1c0 .14.09.28.21.35l7.88 4.54a.4.4 0 0 0 .4 0l7.87-4.56a.4.4 0 0 0 .2-.35v-9.1a.43.43 0 0 0-.21-.35L10.19.55a.4.4 0 0 0-.4 0L1.92 5.11a.4.4 0 0 0-.2.35Z"
            fill="none"
          />
        </clipPath>
      </defs>
      <g clip-path="url(#gem-clip)">
        <path
          fill="url(#gem-grad-top)"
          d="m5.06 12.84 4.93 2.86 4.94-2.85.01-5.69-4.93-2.86-4.94 2.85-.01 5.69z"
        />
        <path
          fill="url(#gem-grad-left-low)"
          d="M5.07 7.15 1.72 5.21l-.01 9.56 3.35-1.93.01-5.69z"
        />
        <path
          fill="url(#gem-grad-top-left)"
          d="M10.01 4.3V.44L1.72 5.21l3.35 1.94 4.94-2.85z"
        />
        <path
          fill="url(#gem-grad-top-right)"
          d="M14.94 7.16 10.01 4.3V.44l8.28 4.79-3.35 1.93z"
        />
        <path
          fill="url(#gem-grad-right-low)"
          d="m14.93 12.85.01-5.69 3.35-1.93-.01 9.56-3.35-1.94z"
        />
        <path
          fill="url(#gem-grad-bottom-right)"
          d="M9.99 15.7v3.86l8.29-4.77-3.35-1.94-4.94 2.85z"
        />
        <path
          fill="url(#gem-grad-bottom-left)"
          d="m5.06 12.84-3.35 1.93 8.28 4.79V15.7l-4.93-2.86z"
        />
        <path
          fill="#6ed5d3"
          d="m14.92 12.84-.14-.08-4.79 2.77v.16l4.93-2.85z"
        />
        <path fill="#8ae0cf" d="m5.08 7.15.14.08 4.79-2.77V4.3L5.08 7.15z" />
        <path fill="#d5eadd" d="m14.93 7.15-.14.08-4.78-2.77V4.3l4.92 2.85z" />
        <path fill="#6ed5d3" d="m5.08 7.15.13.08v5.53l-.14.08.01-5.69z" />
        <path fill="#8ae0cf" d="m14.78 12.76.14.08.01-5.68-.14.08-.01 5.52z" />
      </g>
    </svg>
  )
}
